<template>
    <router-link to="/nothing" class="main">
        <div class="item header">STROMPOPPER</div>
        <div class="item vid">
            <video autoplay="autoplay" loop="loop" muted="muted">
                <source src="static/cube.mp4" />
            </video>
        </div>
        <div class="item footer">SIGN IN FOR NOTHING</div>
    </router-link>
</template>

<script>
export default {
    data() {
        return {

        };
    }
}
</script>

<style scoped>
.main {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    text-decoration: none;
    flex-direction: column;
    flex-wrap: wrap;
    font-size: 3vh;
    min-height: 0;
    height: 100%;
    width: 100%;
    font-family: monospaced;
}

.header {
    letter-spacing: 0.7ch;
}

.footer {
    letter-spacing: 1ch;
}

.item {
    text-align: center;
    flex: 1;
    padding: 1em;
    width: 100%;
    box-sizing: border-box;
}

.vid {
    padding: 0;
    flex: 100;
    display: flex;
    justify-content: center;
    align-items: center;
}

video {
    max-width: 100vw;
    max-height: 60vh;
}

/*
video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

 */
</style>



// WEBPACK FOOTER //
// src/components/SignIn.vue